import { api } from 'data/api/api'

import { ShippingContactConfigurationResp } from '../types/shipping-contact'

export const getShippingContactConfiguration = () =>
  api.get<ShippingContactConfigurationResp>('/configurations/shipping_contact')
